module.exports = __webpack_public_path__ + "img/logo-white.64c9f7d3.png";